<template>
  <div id="treeContainer" class="TreeContainer">
    <lm-icon-button class="TreeClose" icon="close" @click="close" />
    <tree />
  </div>
</template>

<script>
import {Events} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'
import Tree from './Tree.vue'
import LmIconButton from '@/components/ui/LmIconButton.vue'

export default {
  name: 'TreeContainer',
  components: {LmIconButton, Tree},
  methods: {
    close() {
      EventHub.emit(Events.CLOSE_TREE)
    }
  }
}
</script>

<style scoped>
.TreeContainer {
  overflow-y: auto;
  width: theme('width.tree');
  border-right: 1px solid #dcdcdc;
  background-color: theme('colors.gray.100');
}
.TreeClose {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 40px;
  height: 40px;
  @media (--desktop) {
    display: none;
  }
}
</style>
